import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import DocumentService from '../../Services/documents.service';

export const fetchJournalEntryPageData = createAsyncThunk(
    'journalEntryPage/fetchData',
    async ({ caseId, startDate, endDate, useRegistrationMonth, isRange, requestKey, token, backgroundRefresh }, { rejectWithValue }) => {
        try {
            const response = await DocumentService.GetJournalEntryPageData({
                caseId,
                startDate,
                endDate,
                useRegistrationMonth,
                isRange
            }, token);
            if (!response.ok) return rejectWithValue(await response.text());
            const json = await response.json();
            return requestKey != null ? { ...json, requestKey, backgroundRefresh } : { ...json, backgroundRefresh };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const initialState = {
    documents: [],
    creditDebitSum: null,
    missingCards: [],
    isClosedReportingMonth: false,
    denseTableCreditDebitHeader: null,
    denseTableCreditDebitRows: null,
    loading: false,
    error: null,
    lastFetchKey: null,
    expectedFetchKey: null,
};

const journalEntryPageSlice = createSlice({
    name: 'journalEntryPage',
    initialState,
    reducers: {
        resetJournalEntryPage: () => initialState,
        setDocuments: (state, action) => {
            state.documents = action.payload;
        },
        setMonthClosed: (state, action) => {
            state.isClosedReportingMonth = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJournalEntryPageData.pending, (state, action) => {
                const backgroundRefresh = action.meta?.arg?.backgroundRefresh;
                const hasExistingData = (state.documents?.length ?? 0) > 0;
                if (!(backgroundRefresh && hasExistingData)) state.loading = true;
                state.error = null;
                const key = action.meta?.arg?.requestKey;
                if (key != null) state.expectedFetchKey = key;
            })
            .addCase(fetchJournalEntryPageData.fulfilled, (state, action) => {
                const r = action.payload;
                const requestKey = r.requestKey;
                if (requestKey != null && state.expectedFetchKey != null && requestKey !== state.expectedFetchKey) {
                    state.loading = false;
                    return;
                }
                state.documents = Array.isArray(r.documents) ? r.documents : (Array.isArray(r.Documents) ? r.Documents : (r.documents ?? r.Documents ?? []));
                state.creditDebitSum = {
                    creditSum: r.creditSum ?? r.CreditSum,
                    debitSum: r.debitSum ?? r.DebitSum,
                    difference: r.difference ?? r.Difference
                };
                state.missingCards = r.missingCards ?? r.MissingCards ?? [];
                state.isClosedReportingMonth = r.isClosedReportingMonth ?? r.IsClosedReportingMonth ?? false;
                state.denseTableCreditDebitHeader = r.denseTableCreditDebitHeader ?? r.DenseTableCreditDebitHeader ?? null;
                state.denseTableCreditDebitRows = r.denseTableCreditDebitRows ?? r.DenseTableCreditDebitRows ?? null;
                state.loading = false;
            })
            .addCase(fetchJournalEntryPageData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetJournalEntryPage, setDocuments, setMonthClosed } = journalEntryPageSlice.actions;
export default journalEntryPageSlice.reducer;
